module.exports = __webpack_public_path__ + "6b1ea2d4c9ce65e9e9869a27c3bdb302.svg";